import type {SessionApprovalMode} from '@github-ui/ahp-relay/permission-mode'

export function resolveNewSessionApprovalMode(
  preferred: SessionApprovalMode,
  availableApprovalModes: readonly SessionApprovalMode[] | undefined,
): SessionApprovalMode | undefined {
  if (availableApprovalModes === undefined || availableApprovalModes.includes(preferred)) return preferred
  if (availableApprovalModes.includes('manual')) return 'manual'
  if (availableApprovalModes.includes('assisted')) return 'assisted'
  return undefined
}
